import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';

const withViewPermission = WrappedComponent => (
  class withViewPermissionWrapper extends PureComponent {
    static propTypes = {
      selectedCompanyCode: PropTypes.string,
      companyCodes: PropTypes.arrayOf(PropTypes.shape({
        cc: PropTypes.string.isRequired,
      })).isRequired,
    };

    render() {
      const { selectedCompanyCode, companyCodes } = this.props;

      const hasViewAccess = companyCodes.some(
        companyCode => companyCode.cc === selectedCompanyCode
      );

      return (
        <WrappedComponent hasViewAccess={hasViewAccess} />
      );
    }
  }
);

export default () => compose(
  connect(({ shared }) => ({
    selectedCompanyCode: shared.companyCode,
    companyCodes: shared.companyCodes,
  })),
  withViewPermission
);
